import React, { FC, PropsWithChildren } from 'react';

import { FormFieldsNumberRow, FormFieldsSection } from '../../components';

import { FRAME_NUMBER_FIELDS } from '../ProgressBarFormFields.consts';

export const ProgressBarFrameSection: FC<PropsWithChildren> = ({
  children
}): React.ReactElement => (
  <FormFieldsSection
    heading="Progress Bar Frame"
    description="Set your frame settings."
    showSeparator
  >
    <FormFieldsNumberRow fields={FRAME_NUMBER_FIELDS} />
    {children}
  </FormFieldsSection>
);
